import { jsPDF } from 'jspdf';
import { registerKarlaFont } from '../../fonts/karlaFont';
import { getReportPeriod } from './utils';
import {
  buildTitlePage,
  buildKPIsPage,
  buildChartPage,
  buildTop5Page,
  buildSitesTablePage,
  buildAnalysisPage,
  buildClosingPage
} from './multisitesPages';

export const generateMultisitesPDF = async (report, sites, monthlyData) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  registerKarlaFont(doc);
  doc.setFont('Karla', 'normal');
  
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  
  await buildTitlePage(doc, report, margin, pageWidth, pageHeight);
  
  doc.addPage();
  await buildKPIsPage(doc, report, sites, margin, pageWidth, pageHeight);
  
  doc.addPage();
  await buildChartPage(doc, report, sites, margin, pageWidth, pageHeight);
  
  doc.addPage();
  await buildTop5Page(doc, report, sites, margin, pageWidth, pageHeight);
  
  doc.addPage();
  await buildSitesTablePage(doc, report, sites, margin, pageWidth, pageHeight);
  
  if (report.energy_manager_analysis) {
    doc.addPage();
    await buildAnalysisPage(doc, report, margin, pageWidth, pageHeight);
  }
  
  doc.addPage();
  await buildClosingPage(doc, report, margin, pageWidth, pageHeight);
  
  const clientName = (report.client_name || 'rapport')
    .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
  
  const monthName = (report.report_month || 'rapport')
    .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_');
  
  const reportYear = report.report_year || new Date().getFullYear();
  const fileName = `rapport_${clientName}_${monthName}_${reportYear}.pdf`;
  
  doc.save(fileName);
  return fileName;
};
